import {useRef} from 'react';
import {ControlledInput} from '../../interfaces/Forms';
import {Col, Form, Row} from 'react-bootstrap';
import clsx from 'clsx';
import {formatBytes} from '../../common/tools/filesize';
import {useIntl} from 'react-intl';

interface FileInputControlledProps {
    value?: File;
    accept?: string;
    required?: boolean
}

const FileInputControlled = ({
    value,
    placeholder,
    name,
    label,
    onChange,
    onBlur,
    onReset,
    touched,
    errors,
    accept,
    required
}: ControlledInput & FileInputControlledProps): JSX.Element => {
    const intl = useIntl();
    const inputRef = useRef<HTMLInputElement | null>(null);

    return (
        <Form.Group controlId={name}>
            <Form.Label className={required ? "fw-bold fs-3 required" : "fw-bold fs-3"}>{label}</Form.Label>
            <Row
                className={
                    clsx({'is-invalid': touched && errors}, {'is-valid': touched && !errors}) +
                    ' rounded-lg bg-celeste-form-bg p-0 m-0 file-input flex-nowrap text-nowrap'
                }
                onClick={() => inputRef.current?.click()}
            >
                <Col xs={'auto'} className="p-5 m-0 file-input-btn">
                    {intl.formatMessage({id: 'INPUT.FILE.BUTTON'})}
                </Col>
                <Col className="h-full d-flex align-items-center">
                    {value
                        ? value.name + ',\t' + formatBytes(value.size)
                        : placeholder ?? intl.formatMessage({id: 'INPUT.FILE.PLACEHOLDER'})}
                </Col>
            </Row>
            <input
                id={name}
                name={name}
                className="visually-hidden"
                type="file"
                onChange={onChange}
                onBlur={onBlur}
                onReset={onReset}
                ref={inputRef}
                accept={accept}
            />
            {touched && errors && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">{errors}</span>
                    </div>
                </div>
            )}
        </Form.Group>
    );
};

export default FileInputControlled;
